<template>
  <div class="modal-content">
    <div class="modal-body">
      <settings
        embedded
        :baseDomain="baseDomain"
        :shopId="shopId"
        :apiKey="apiKey"
        :component="component"
        :focus="focus"
        v-on:close="hideModal"
        v-on:save="save"
      />
    </div>
  </div>
</template>

<script>

import Settings from '~/components/Settings'

export default {
  props: ['baseDomain', 'shopId', 'apiKey', 'component', 'focus'],
  methods: {
    hideModal () {
      this.$emit('close')
    },
    save (data) {
      this.$emit('save', data)
    }
  },
  components: {
    Settings
  }
}

</script>
